module.exports = __webpack_public_path__ + "media/images/flags/4x3/pol-ff5284c3db807f24fba7120e7ba53e52.svg";